// components/SessionRecorder.jsx
import { useEffect, useRef } from 'react';
import * as rrweb from 'rrweb';
import { urlapi } from '../../lib/backend/data';

export default function SessionRecorder() {
  const eventsRef = useRef([]);

  useEffect(() => {
    const stopFn = rrweb.record({
      emit(event) {
        eventsRef.current.push(event);
      },
    });

    const interval = setInterval(() => {
      if (eventsRef.current.length > 0) {
        const payload = [...eventsRef.current];
        eventsRef.current = [];

        fetch(`${urlapi}/session/record`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ sessionId: getSessionId(), events: payload }),
        });
      }
    }, 10000);

    return () => {
      stopFn();
      clearInterval(interval);
    };
  }, []);

  return null;
}

function getSessionId() {
  let id = localStorage.getItem('session-id');
  if (!id) {
    id = `${Date.now()}-${Math.random().toString(36).substring(2)}`;
    localStorage.setItem('session-id', id);
  }
  return id;
}
